import React, {useState, Fragment, useEffect} from 'react';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPersonalizado, obtenerRegistrosPorURL } from 'store/actions/customAction';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { Card, CardContent, Typography } from '@mui/material';
import TituloConIcono from 'components/tituloConIcono';
import { NavigateNext, Visibility } from '@mui/icons-material';
import Formulario from 'components/formulario';
import { useHistory } from 'react-router-dom';
import {useDispatch} from 'react-redux';
import ModalDeImagen from 'components/ImageModal';
import { functions } from 'constantes';

let idDocumento = "";
let datosDeEmpresaGlobal = {}
let plantillaDocumento = "";
const PlanDeMediosAlternos = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const[base64Imagen, setBase64Imagen] = useState("");
    const[mostrarLogo, setMostrarLogo] = useState(false);
    const[gestionarDeMediosAlternativos] = useState("gestionarDeMediosAlternativos");
    const[message, setMessage] = useState(false);

    useEffect( () => {
        consultarPlanDeMedios()
    }, [])

    const consultarPlanDeMedios = async () => {
        setcargandoSolicitud(true);
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        ServiciosDelAPI[gestionarDeMediosAlternativos].metodoDeBusqueda.clear();
        let respuesta = await dispatch(obtenerRegistrosPersonalizado({ controller: gestionarDeMediosAlternativos, saveInStore: false, action: "verificarExistencia", nombreDelMetodo: "verificarExistencia"}));

        setcargandoSolicitud(false);

        plantillaDocumento = "";
        buttonList.saveData.label = "Guardar datos";
        copiaDeCampos.documentoBase64.validators.required = true;
        copiaDeCampos.documentoBase64.disabledVisualization = false;
        idDocumento = "";
        copiaDeCampos.documentoBase64.value = ""
        setMessage(false)

        if(respuesta?.error) {
            setCamposDelFormulario(copiaDeCampos);
            if(respuesta?.error?.message == "YA EXISTE UN DOCUMENTO INSERTADO EN ESTA SECCION") {
              setMessage(true)
              copiaDeCampos.documentoBase64.value = "";
              buttonList.saveData.label = "Editar documento";
              idDocumento = 1;
              setCamposDelFormulario(copiaDeCampos);
              return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "No se encontraron datos", mostrarRespuesta: true, });
            }
            return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "No se encontraron datos", mostrarRespuesta: true, });
        }

        if(respuesta?.data?.length === 0) return setCamposDelFormulario(copiaDeCampos);
    }

    const obtenerLogo = async () => {

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: gestionarDeMediosAlternativos, saveInStore: false, nombreDelMetodo: "obtenerImagenDeEmpresa", parametro: datosDeEmpresaGlobal?.nit}));

        setcargandoSolicitud(false);

        if(respuesta?.error) return changeDataResponse('error', respuesta?.error?.message || "No encontramos información del documento", true)

        if(!respuesta?.data ) return changeDataResponse('error', "No encontramos información del documento", true)

        setBase64Imagen(respuesta.data)
        setMostrarLogo(true)
    }

    const cerrarModalDeImagen = () => setMostrarLogo(false)

    const descargarPautaIngreasada = ( ) => plantillaDocumento ? functions.descargarBase64EnPDF(plantillaDocumento, "PAUTA_DIGITAL_META_INGRESADA.xlsx") : alertaPersonalizadaSwal( "¡No ha registro información!",'')
    ;

    const [camposDelFormulario, setCamposDelFormulario] = React.useState({
        title:{
            idelement: "title", title:'Cargar plan de medios alternativos', position:"center", elementType:'titulo', showTitleForm: true, name: "title", value: "", isError:false,
        },
        documentoBase64:{
            idelement: "documentoBase64", value: "", label: "Plan de medios (Máximo 5 MB)",
            validators: {required: true, size: "5 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled': false, name:"documentoBase64", fileWidth: true, src: '/menu/Iconos Sistema SIDI_Mesa de trabajo 1 copia 23.png', multiple: false, accept:".xlsx", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "Plan de medios alternativos", iconButton: <Visibility />, handleVisualization: obtenerLogo,  fileType: "png", nameOfFile: ""
        },
        // boton:{
        //     idelement: "boton", elementType:'boton', name: "boton", value: "", isError:false, icon: "cloud_download", handleFunction: descargarPautaIngreasada, title: "Descargar pauta digital meta ingresada", color: "#205690"
        // },
        acciones:{
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const cancelAction = () => history.goBack('/')

    const guardarDatos = async (dataForm) => {
        setcargandoSolicitud(true);

        const { documentoBase64 } = dataForm;

        let datosAEnviar = {};
        let respuesta = {};

        if(idDocumento) {
            datosAEnviar = { controller: gestionarDeMediosAlternativos, action: "editar", data: { documentoBase64 }, nombreDelMetodo: `editar` };
            respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        } else {
            datosAEnviar = { controller: gestionarDeMediosAlternativos, action: "crear", data: { documentoBase64 }, nombreDelMetodo: "" };
            respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        }

        setcargandoSolicitud(false);
        if(respuesta?.error) return alertaPersonalizadaSwal(respuesta?.error?.message || "No se puedo guardar los datos, intente nuevamente!",'')

        alertaPersonalizadaSwal(respuesta?.data || "Datos guardados correctamente", "", "success")
        consultarPlanDeMedios()
    }

    const [buttonList]= React.useState({
        "saveData":{"label":  "Guardar Datos", "icon": <NavigateNext />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelAction":{"label":"Salir", "icon": <NavigateNext />,"callback":cancelAction,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta,})

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
            <TituloConIcono
                mostrarTiempo={false}
                showButton={false}
                mostrarBotones={false}
                title={`Plan de Medios Alternativos`}
                handleClickButton1={undefined}
                handleClickButton2={undefined}
                widthIcon="90px" heighIcont="80px"
            />
            {message && (
              <Typography variant="h5" style={{textAlign: 'center', fontWeight: 'bold'}} >YA EXISTE UN DOCUMENTO INSERTADO EN ESTA SECCIÓN, PERO PUEDE EDITARLO.</Typography>
            )}
            <Card>
                <CardContent>
                    <Formulario
                        elements={camposDelFormulario}
                        buttonList={buttonList}
                    />
                </CardContent>
            </Card>
            {mostrarLogo && (
                <ModalDeImagen base64={base64Imagen} title={"Plantilla de requisitos"} open={mostrarLogo} handleClose={cerrarModalDeImagen} showDownloadButton={false} src={base64Imagen} />
            )}
        </Fragment>
    );
}

export default PlanDeMediosAlternos;
